export var TapeUploadStatus;
(function (TapeUploadStatus) {
    TapeUploadStatus["UPLOADING"] = "uploading";
    TapeUploadStatus["STAGED"] = "staged";
    TapeUploadStatus["COMMITTED"] = "committed";
})(TapeUploadStatus || (TapeUploadStatus = {}));
export var TapeIngestStatus;
(function (TapeIngestStatus) {
    TapeIngestStatus["QUEUED"] = "queued";
    TapeIngestStatus["RUNNING"] = "running";
    TapeIngestStatus["COMPLETE"] = "complete";
    TapeIngestStatus["BLOCKED"] = "blocked";
    TapeIngestStatus["INVALID_MAPPING"] = "invalid_mapping";
    TapeIngestStatus["ERROR"] = "error";
})(TapeIngestStatus || (TapeIngestStatus = {}));
export const isTapeRole = (value) => value === 'loans' || value === 'payments';
//# sourceMappingURL=tapes.js.map